import React from 'react';

import Player from './Player';
import Subtitle from './Subtitle';
import Button from 'components/Button';
import Tooltip from 'components/Tooltip';

import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
} from 'react-icons/fi';

import { Tool, Main, Left, Right } from './styles';

export default function(props) {
  return (
    <Main>
      <Left>
        <Player {...props} />
        <Tool>
          <div className="item">
            <div className="title">
              <p>time-offset</p>
            </div>
            <div className="value">
              <Button
                id="id_btn_timeoff-1000"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(-1, 'all')}
              >
                <FiChevronsLeft />
              </Button>
              <Tooltip target="id_btn_timeoff-1000">-1000ms</Tooltip>
              <Button
                id="id_btn_timeoff-100"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(-0.1, 'all')}
              >
                <FiChevronLeft />
              </Button>
              <Tooltip target="id_btn_timeoff-100">-100ms</Tooltip>
              <Button
                id="id_btn_timeoff100"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(0.1, 'all')}
              >
                <FiChevronRight />
              </Button>
              <Tooltip target="id_btn_timeoff100">+100ms</Tooltip>
              <Button
                id="id_btn_timeoff1000"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(1, 'all')}
              >
                <FiChevronsRight />
              </Button>
              <Tooltip target="id_btn_timeoff1000">+1000ms</Tooltip>
            </div>
          </div>
          <div className="item">
            <div className="title">
              <p>left-time-offset</p>
            </div>
            <div className="value">
              <Button
                id="id_btn_timeoff-1000"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(-1, 'left')}
              >
                <FiChevronsLeft />
              </Button>
              <Tooltip target="id_btn_timeoff-1000">-1000ms</Tooltip>
              <Button
                id="id_btn_timeoff-100"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(-0.1, 'left')}
              >
                <FiChevronLeft />
              </Button>
              <Tooltip target="id_btn_timeoff-100">-100ms</Tooltip>
              <Button
                id="id_btn_timeoff100"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(0.1, 'left')}
              >
                <FiChevronRight />
              </Button>
              <Tooltip target="id_btn_timeoff100">+100ms</Tooltip>
              <Button
                id="id_btn_timeoff1000"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(1, 'left')}
              >
                <FiChevronsRight />
              </Button>
              <Tooltip target="id_btn_timeoff1000">+1000ms</Tooltip>
            </div>
          </div>
          <div className="item">
            <div className="title">
              <p>right-time-offset</p>
            </div>
            <div className="value">
              <Button
                id="id_btn_timeoff-1000"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(-1, 'right')}
              >
                <FiChevronsLeft />
              </Button>
              <Tooltip target="id_btn_timeoff-1000">-1000ms</Tooltip>
              <Button
                id="id_btn_timeoff-100"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(-0.1, 'right')}
              >
                <FiChevronLeft />
              </Button>
              <Tooltip target="id_btn_timeoff-100">-100ms</Tooltip>
              <Button
                id="id_btn_timeoff100"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(0.1, 'right')}
              >
                <FiChevronRight />
              </Button>
              <Tooltip target="id_btn_timeoff100">+100ms</Tooltip>
              <Button
                id="id_btn_timeoff1000"
                fill
                color="font"
                round="true"
                onClick={() => props.timeOffsetSubtitles(1, 'right')}
              >
                <FiChevronsRight />
              </Button>
              <Tooltip target="id_btn_timeoff1000">+1000ms</Tooltip>
            </div>
          </div>
        </Tool>
      </Left>
      <Right>
        <Subtitle {...props} />
      </Right>
    </Main>
  );
}
